export const Oval = ({ isFilled }: { isFilled?: boolean }) => {
  return (
    <svg
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill={isFilled ? 'black' : 'none'}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.75 11C15.75 13.9905 14.8681 16.6877 13.4547 18.6311C12.0411 20.5748 10.1094 21.75 8 21.75C5.89055 21.75 3.95893 20.5748 2.54533 18.6311C1.1319 16.6877 0.25 13.9905 0.25 11C0.25 8.00953 1.1319 5.31233 2.54533 3.36887C3.95893 1.42516 5.89055 0.25 8 0.25C10.1094 0.25 12.0411 1.42516 13.4547 3.36887C14.8681 5.31233 15.75 8.00953 15.75 11Z"
        stroke="black"
        strokeWidth="0.5"
      />
    </svg>
  );
};
